import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

interface MenuItemProps {
  active: number;
  color: string;
}

export const MenuItem = styled(Link)<MenuItemProps>`
  ${props =>
    props.active === 1 &&
    css`
      &::after {
        background: ${props.color} !important;
      }

      i {
        color: ${props.color} !important;
      }
    `}
`;

export const MenuCenter = styled(Link)<MenuItemProps>`
  span {
    background: ${props => props.color} !important;
    span {
      background: #bf312f !important;
    }
  }

  ${props =>
    props.active === 1 &&
    css`
      &::after {
        background: ${props.color} !important;
      }
    `}
`;

export const Badge = styled.span`
  background: #53e5a5 !important;
`;

export const TopButton = styled.a.attrs({ href: '#header' })`
  display: none;
  background: #bf312f;
  color: #fff !important;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  /* display: flex; */
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 10px;
  bottom: 80px;
  z-index: 9;
`;
